import { Directive, HostListener, Input } from "@angular/core";
import { GtagEvent } from 'src/common/gtagEvent';


@Directive({
    selector: '[gtagEvent], [gtagEvents]'
})
export class GtagEventDirective {

    @Input("gtagEvent")
    eventName: string;

    @Input("gtagEvents")
    eventNames: string[];

    @Input("gtagCategory")
    eventCategory: string;

    @Input("gtagLabel")
    eventLabel: string;

    @Input("gtagValue")
    eventValue: number;

    constructor( private gtagEvent: GtagEvent ) {
    }

    @HostListener( 'click' )
    onClick() {
        if( this.eventName )
            this.gtagEvent.emit( this.eventName, this.eventCategory, this.eventLabel, this.eventValue );
        else if( this.eventNames.length > 0 )
            this.eventNames.forEach( eventName => this.gtagEvent.emit( eventName, this.eventCategory, this.eventLabel, this.eventValue ) );
    }
}